import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
export function getPreviewHref(article) {
  const {
    values: {
      hs_preview_key: previewKey,
      hs_absolute_url: absoluteUrl,
      hs_id: id
    }
  } = article;
  if (!previewKey) {
    return absoluteUrl;
  }
  const query = stringify({
    portalId: PortalIdParser.get(),
    preview_key: previewKey
  });
  return `https://preview${enviro.isQa() ? 'qa' : ''}.hs-sites.com/_hcms/preview/content/${id}?${query}`;
}
export function getLivePreviewHref(article) {
  const {
    values: {
      hs_preview_key: previewKey,
      hs_absolute_url: absoluteUrl,
      hs_id: id
    }
  } = article;
  if (!previewKey) {
    return absoluteUrl;
  }
  const query = stringify({
    hs_preview: `${previewKey}-${id}`
  });
  return `${absoluteUrl}?${query}`;
}
export function getPreviewOrigin(previewDomain) {
  return `${document.location.protocol}//${previewDomain || window.hsPreviewDomain}`;
}
export function getKnowledgeBasePreviewUrl(templatePath, language, knowledgeBaseId) {
  const queryParams = {
    buffer_theme: true,
    language,
    path: templatePath,
    portalId: PortalIdParser.get(),
    preview_theme: true,
    // indicates to use preview/buffer data
    content_group_id: knowledgeBaseId
  };

  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
  return `${getPreviewOrigin()}/_hcms/preview/template/multi?${stringify(queryParams)}`;
}